import * as React from "react";
import { useMediaQuery } from "./use-media-query";
import { Button } from "./ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "./ui/dialog";
import {
  Drawer,
  DrawerClose,
  DrawerContent,
  DrawerDescription,
  DrawerFooter,
  DrawerHeader,
  DrawerTitle,
  DrawerTrigger,
} from "./ui/drawer";
import { useUser } from "../lib/context/UserContext";
import { useLocation } from "react-router-dom";
import { extractModuleFromPath } from "../lib/Misc";
import UnauthorisedAccess from "../UnauthorisedAccess";

export function ResponsiveDrawerForm(props) {
  const isDesktop = useMediaQuery("(min-width: 768px)");

  const { permission, userData } = useUser();

  const location = useLocation();
  const groupCheck = (type) => {
    if (module === "trust-general-settings") {
      const groupOfTrustGeneralSettings = [
        "trusts",
        "integrations",
        "yodlee",
        "xero",
        "template",
      ];
      if (
        groupOfTrustGeneralSettings?.find(
          (item) => props?.popupType === item && permission?.[item]?.[type],
        )
      ) {
        return true;
      }
    } else if (module === "banking") {
      const groupOfBanking = [
        "yodlee",
        "bank-reconciliations",
        "bank-transactions",
        "users",
        "reports",
      ];

      if (
        groupOfBanking?.find(
          (item) => props?.popupType === item && permission?.[item]?.[type],
        )
      ) {
        return true;
      }
    }
    if (module === "aml-ctf") {
      const groupOfAMLCTF = [
        "risk-assessments",
        "policies",
        "program-summaries",
        "cdds",
        "incidents",
        "trainings",
        "governance-summaries",
      ];

      if (
        groupOfAMLCTF?.find(
          (item) => props?.popupType === item && permission?.[item]?.[type],
        )
      ) {
        return true;
      }
    } else if (module === "statement-report") {
      const groupOfReport = ["reports"];

      if (
        groupOfReport?.find(
          (item) => props?.popupType === item && permission?.[item]?.[type],
        )
      ) {
        return true;
      }
    } else {
      return false;
    }
  };

  const module = extractModuleFromPath(location.pathname);

  const allowedModule = ["general-settings", "abas", "account-settings"];  

  const hasReadAccess =
    props?.popupType && groupCheck("read")
      ? true
      : allowedModule?.find((item) => item === module)
        ? true
        : permission?.[module]?.read;
  const hasWriteAccess =
    props?.popupType && groupCheck("write")
      ? true
      : allowedModule?.find((item) => item === module)
        ? true
        : permission?.[module]?.write;

  React.useEffect(() => {
    if (props.handleClose && props?.open === false) {
      props.handleClose();
    }
    if (props.handleOpen && props?.open === true) {
      props.handleOpen();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props?.open]);

  if (isDesktop) {
    return (
      <Dialog open={props?.open} onOpenChange={props?.setOpen}>
        {props?.buttonText && (
          <DialogTrigger asChild>
            <Button className={props?.buttonClassName}>
              {props?.buttonText}
            </Button>
          </DialogTrigger>
        )}
        <DialogContent
          className={
            props.className
              ? "sm:max-w-[90vw] focus:outline-none min-h-[170px] " +
                props.className
              : " sm:max-w-[90vw] focus:outline-none min-h-[170px]"
          }
          onOpenAutoFocus={(e) => e.preventDefault()} // ⛔ stop auto-focusing
        >
          <DialogHeader>
            {/* <DialogTitle className="bg-webPrimary w-fit py-1 px-3 rounded-lg text-white">{props?.title}</DialogTitle> */}
            <DialogTitle
              className={
                props?.confirmBox
                  ? "text-center text-webPrimary"
                  : "text-webPrimary"
              }
            >
              {props?.title}
            </DialogTitle>
            <DialogDescription>{props?.description}</DialogDescription>
          </DialogHeader>
          {/* {props?.write && !hasWriteAccess ? (  */}
          {userData?.role?.type !== "Admin" &&
          props?.write &&
          !hasWriteAccess ? (
            <UnauthorisedAccess expandList={true} popup={true} />
          ) : userData?.role?.type !== "Admin" &&
            props?.read &&
            !hasReadAccess ? (
            <UnauthorisedAccess expandList={true} popup={true} />
          ) : (
            props.children
          )}
          {/* {props.children} */}
        </DialogContent>
      </Dialog>
    );
  }

  return (
    <Drawer open={props?.open} onOpenChange={props?.setOpen}>
      {props?.buttonText && (
        <DrawerTrigger asChild>
          <Button className={props?.buttonClassName}>
            {props?.buttonText}
          </Button>
        </DrawerTrigger>
      )}
      <DrawerContent className={props.className ? props.className : ""}>
        <DrawerHeader className="text-left">
          <DrawerTitle
            className={
              props?.confirmBox
                ? "text-center text-webPrimary"
                : "text-webPrimary"
            }
          >
            {props?.title}
          </DrawerTitle>
          <DrawerDescription>{props?.description}</DrawerDescription>
        </DrawerHeader>
        {/* {props.children} */}
        {userData?.role?.type !== "Admin" && props?.write && !hasWriteAccess ? (
          <UnauthorisedAccess expandList={true} />
        ) : userData?.role?.type !== "Admin" &&
          props?.read &&
          !hasReadAccess ? (
          <UnauthorisedAccess expandList={true} />
        ) : (
          props.children
        )}

        <DrawerFooter className="pt-2">
          {!props?.mobileCancelHidden && (
            <DrawerClose asChild>
              <Button variant="outline">Cancel</Button>
            </DrawerClose>
          )}
        </DrawerFooter>
      </DrawerContent>
    </Drawer>
  );
}
